export enum CoreParams {
  /**
   * Query parameter to indicate mock data should be used to make testing easier.
   */
  Mock = 'mock',
}
